<section class="create-form-section">
  <div class="container">

    <div class="card">

      <div class="header-row">

        <button type="button" class="icon-btn back" (click)="goBack()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>


        <h3 class="page-title">
          {{ mode === 'create' ? 'Create User'
          : mode === 'edit' ? 'Edit User'
          : 'User Details' }}
        </h3>

        <div class="flex-spacer"></div>

        <div class="header-actions" *ngIf="mode === 'view'">
          <button class="icon-btn password" (click)="openSystemChangePasswordDialog()">
            <i class="fa-solid fa-key"></i>
          </button>

          <button class="icon-btn edit" (click)="goToEdit()">
            <i class="fa-solid fa-pen-to-square"></i>
          </button>

          <button class="icon-btn delete" (click)="deleteUser()">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>

        <div class="header-actions" *ngIf="mode === 'edit'">
          <button class="icon-btn view" (click)="viewUser()">
            <i class="fa-solid fa-eye"></i>
          </button>

          <button class="icon-btn delete" (click)="deleteUser()">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>

      </div>

      <div class="form-wrapper" [formGroup]="userForm">

        <label>Email</label>
        <input type="email" formControlName="email">

        <div class="error-text" *ngIf="userForm.get('email')?.touched && userForm.get('email')?.invalid">
          <span *ngIf="userForm.get('email')?.errors?.['required']">Email is required.</span>
          <span *ngIf="userForm.get('email')?.errors?.['email']">Invalid email format.</span>
        </div>


        <label>Name</label>
        <input type="text" formControlName="name">

        <div class="error-text" *ngIf="userForm.get('name')?.touched && userForm.get('name')?.invalid">
          <span *ngIf="userForm.get('name')?.errors?.['required']">Name is required.</span>
        </div>


        <div *ngIf="mode === 'create'">
          <label>Password</label>
          <div class="password-container">
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password">
            <button *ngIf="mode === 'create'" type="button" class="icon-btn view" (click)="togglePasswordVisibility()">
              <i [ngClass]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
            </button>
          </div>

          <div class="error-text"
            *ngIf="mode === 'create' && userForm.get('password')?.touched && userForm.get('password')?.invalid">
            <span *ngIf="userForm.get('password')?.errors?.['required']">Password is required.</span>
          </div>
        </div>


        <label>Role</label>
        <select formControlName="role">

          <option value="">Select Role</option>
          <option *ngFor="let r of roles" [value]="r.roleId"
            [disabled]="r.name === 'SYSTEM_OWNER' || r.name === 'PROJECT_OWNER'">
            {{ r.name }}
          </option>
        </select>
        <div class="hint-text" *ngIf="mode === 'edit'" style="font-size:13px; color:#777; margin-top:4px;">
          Changing a user role will immediately affect their permissions.
        </div>


        <div class="error-text" *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid">
          <span *ngIf="userForm.get('role')?.errors?.['required']">Role is required.</span>
        </div>


        <div *ngIf="mode === 'view'">
          <label>User ID</label>
          <input [value]="userId" disabled>
        </div>

        <div *ngIf="mode === 'view'">
          <label>Creation Date</label>
          <input type="text" [value]="creationDate | date:'yyyy-MM-dd HH:mm'" disabled>
        </div>
        <div class="actions" style="margin-top:20px;">
          <button *ngIf="mode === 'create'" class="btn-primary" (click)="createUser()">+ Create User</button>
          <button *ngIf="mode === 'edit'" class="btn-primary" (click)="onRoleSelectionChange()">💾 Update Role</button>
        </div>

      </div>

    </div>

  </div>
</section>
